import { createContext, useContext } from "react";

export type PredictionAsset = "#BTC" | "#ETH";

export const AssetContext = createContext<PredictionAsset>("#BTC");
export const useAssetContext = () => useContext(AssetContext);
